import React from 'react';
import styled, { css } from 'styled-components';
import Check from 'utils/images/check.svg';

const CheckboxStyles = styled.span`
  ${props => (props.tall ? '41px' : '30px')};
  height: ${props => (props.tall ? '41px' : '30px')};
  border-radius: 49px;
  background-color: white;
  border: 1px solid;
  border-color: ${props => (props.selected ? 'black' : '#DDDDDD')};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 8px 12px;
  font-family: 'Basier Circle';
  line-height: 16px;
  font-size: 12px;
  color: black;
  max-width: max-content;
  ${props =>
    props.noMargin
      ? css`
          margin: 0px !important;
        `
      : undefined}: hover {
    border-color: black;
    cursor: pointer;
  }

  ${props =>
    props.disabled &&
    css`
      opacity: 0.4;

      :hover {
        border-color: #dddddd;
        cursor: default;
      }
    `}
`;

const CheckboxInput = styled.span`
  height: 14px;
  width: 14px;
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 2px;
  margin-right: 6px !important;
  background-color: white;

  ${props =>
    props.selected &&
    css`
      border-color: black;
      background-color: black;
    `}
`;

const CheckIcon = styled.img`
  margin-left: 2px;
  margin-bottom: 4px; //3px
`;

export function Checkbox(props) {
  const label = props.label || props.value;

  return (
    <CheckboxStyles
      style={props.style}
      className={props.className}
      selected={props.isChecked}
      disabled={props.disabled}
      onClick={() =>
        props.disabled ? null : props.onSelect(props.value, !props.isChecked)
      }
      tall={props.tall}
      noMargin={props.noMargin}
    >
      <CheckboxInput selected={props.isChecked}>
        <CheckIcon src={Check} />
      </CheckboxInput>
      <span>{label}</span>
    </CheckboxStyles>
  );
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Checkbox/Checkbox.jsx